class FetchDefaultOptions {
  public csrfToken: string = '';

  public forGet(): RequestInit {
    return {
      method: 'GET',
      credentials: 'include',
    };
  }

  public forPost(data: any): RequestInit {
    return {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-RequestVerificationToken': this.csrfToken,
      },
      body: JSON.stringify(data),
    };
  }

  public forPut(data?: any): RequestInit {
    return {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-RequestVerificationToken': this.csrfToken,
      },
      body: JSON.stringify(data),
    };
  }

  public forPatch(data: any): RequestInit {
    return {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-RequestVerificationToken': this.csrfToken,
      },
      body: JSON.stringify(data),
    };
  }

  public forDelete(): RequestInit {
    return {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'X-RequestVerificationToken': this.csrfToken,
      },
    };
  }
}

const options = new FetchDefaultOptions();

export {
  options as FetchDefaultOptions,
};
